import React from 'react';
import { TableCell } from '@mui/material';
import _ from 'lodash';
import { getNumberComma } from '../../utils/numberUtils';
import { vendorDeptHeaderTyps } from '../../utils/vendorStaticData';

const VendorDeptStaticCell = ({ headerRows, data }) => {
  if (!headerRows || !data) {
    return null;
  }

  return (
    headerRows &&
    headerRows.map((field, fIndex) => {
      return vendorDeptHeaderTyps.map((type, tIndex) => {
        let key = `${fIndex}_${tIndex}`;

        let value = _.has(data, `${field.val}.${type.id}`)
          ? data[field.val][type.id]
          : '-';
        let formatValue = type.id !== 'profit' ? getNumberComma(value) : value;
        let widthValue = type.id !== 'profit' ? '90px' : '80px';

        return (
          <TableCell sx={{ width: widthValue }} align="right" key={key}>
            {formatValue}
          </TableCell>
        );
      });
    })
  );
};

export default VendorDeptStaticCell;
